import React from 'react';
import DefaultLayout from '@presentation/layouts/DefaultLayout';
import BenefitsHub, { type BenefitTopicSummary } from '@presentation/pages/Benefits/BenefitsHub';

const makeBenefitsHub = (topics: BenefitTopicSummary[]) => (
	<DefaultLayout>
		<BenefitsHub topics={topics} />
	</DefaultLayout>
);

export default makeBenefitsHub;
